// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"94":"Login","561":"Dashboard"}[chunkId] || chunkId) + "." + {"91":"353b42ba","94":"117d7086","204":"cb59e332","453":"8e967287","561":"8986a454","635":"9dc7c4ca","904":"0f8c2e7e"}[chunkId] + ".chunk.js";
};